const MAGIC_DATE = new Date("2023-06");

module.exports = {
    MAGIC_DATE,
};
